module.exports = __webpack_public_path__ + "static/img/calm.a6216712.png";